// extracted by mini-css-extract-plugin
export var resizer = "_h2-0";